export const dataStatusCheck = (bulkUploadList) => {
    let tempFlag = false
    for (let i = 0; i < bulkUploadList.length; i++) {
        if (bulkUploadList[i].status === 'PROCESSING') {
            tempFlag = true;
            break;
        } else {
            tempFlag = false
        }
    }
    return tempFlag
}